// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/oldpaper.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section.num4 {
    padding: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  .Websection-title {
    text-align: center;
    font-family: "Satisfy", cursive;
    font-weight: 400;
    font-style: normal;
    font-size: 58px;
    color: #333;
    margin-bottom: 20px;
  }
  
  /* Top Card */
  .Webtop-card {
    display: flex;
    gap: 20px;
    width: 100%;
    margin-bottom: 20px;
  }
  
  .line-graph-card,
  .pie-graph-card {
    height: 400px;
    background-color: rgba(255, 255, 255, 0.5);
    min-height: 200px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .chart-card-header {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    gap: 5px;
  }
  
  .chart-card-header i {
    font-size: 18px;
    color: #333;
    cursor: pointer;
  }
  
  .line-graph-card, .pie-graph-card, .bar-chart-card, .topic-card {
    position: relative;
  }

  .line-graph-card{
    width: 70%;
  }
  .pie-graph-card{
    width: 30%;
  }
  
  /* Bottom Card */
  .Webbottom-card {
    display: flex;
    gap: 20px;
    width: 100%;
    margin-bottom: 20px;
  }
  
  .bar-chart-card,
  .topic-card {
    /* flex: 1; */
    height: 300px;
    min-height: 200px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .topic-card{
    width: 30%;
    text-align: center;
    padding-bottom: 3px;
  }
  .bar-chart-card{
    width: 70%;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  
  .topic-card h3 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
  }
  
  .topic-card p {
    font-size: 14px;
    line-height: 1.5;
    color: #666;
  }
  
  /* Media Queries for Responsiveness */
  @media (max-width: 768px) {
    .Webtop-card {
      flex-direction: column;
    }
  
    .line-graph-card,
    .pie-graph-card {
      width: 100%;
      height: 300px;
    }
  
    .Webbottom-card {
      flex-direction: column;
    }
  
    .bar-chart-card,
    .topic-card {
      width: 100%;
      height: auto;
    }
  }
  
  .Webcursor {
    display: inline-block;
    width: 2px; 
    height: 1.4em;
    background-color: #E4B300;
    vertical-align: bottom;
    animation: blink 0.7s steps(2, start) infinite;
    margin-left: 2px;
  }
  
  @keyframes blink {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/App/OSVisitGraph.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yDAA8C;IAC9C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA,aAAa;EACb;IACE,aAAa;IACb,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,0CAA0C;IAC1C,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA,qCAAqC;EACrC;IACE;MACE,sBAAsB;IACxB;;IAEA;;MAEE,WAAW;MACX,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;;MAEE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;IAC9C,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF","sourcesContent":[".section.num4 {\r\n    padding: 20px;\r\n    background-image: url('./images/oldpaper.png');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n  }\r\n  \r\n  .Websection-title {\r\n    text-align: center;\r\n    font-family: \"Satisfy\", cursive;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-size: 58px;\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  /* Top Card */\r\n  .Webtop-card {\r\n    display: flex;\r\n    gap: 20px;\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .line-graph-card,\r\n  .pie-graph-card {\r\n    height: 400px;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    min-height: 200px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    padding-bottom: 5px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n\r\n  .chart-card-header {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 10px;\r\n    display: flex;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .chart-card-header i {\r\n    font-size: 18px;\r\n    color: #333;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .line-graph-card, .pie-graph-card, .bar-chart-card, .topic-card {\r\n    position: relative;\r\n  }\r\n\r\n  .line-graph-card{\r\n    width: 70%;\r\n  }\r\n  .pie-graph-card{\r\n    width: 30%;\r\n  }\r\n  \r\n  /* Bottom Card */\r\n  .Webbottom-card {\r\n    display: flex;\r\n    gap: 20px;\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .bar-chart-card,\r\n  .topic-card {\r\n    /* flex: 1; */\r\n    height: 300px;\r\n    min-height: 200px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n  .topic-card{\r\n    width: 30%;\r\n    text-align: center;\r\n    padding-bottom: 3px;\r\n  }\r\n  .bar-chart-card{\r\n    width: 70%;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n  }\r\n  \r\n  .topic-card h3 {\r\n    margin-bottom: 10px;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .topic-card p {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    color: #666;\r\n  }\r\n  \r\n  /* Media Queries for Responsiveness */\r\n  @media (max-width: 768px) {\r\n    .Webtop-card {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .line-graph-card,\r\n    .pie-graph-card {\r\n      width: 100%;\r\n      height: 300px;\r\n    }\r\n  \r\n    .Webbottom-card {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .bar-chart-card,\r\n    .topic-card {\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n  }\r\n  \r\n  .Webcursor {\r\n    display: inline-block;\r\n    width: 2px; \r\n    height: 1.4em;\r\n    background-color: #E4B300;\r\n    vertical-align: bottom;\r\n    animation: blink 0.7s steps(2, start) infinite;\r\n    margin-left: 2px;\r\n  }\r\n  \r\n  @keyframes blink {\r\n    from {\r\n      opacity: 1;\r\n    }\r\n    to {\r\n      opacity: 0;\r\n    }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
